// Commercial Title Page layout, shared by the form and the PDF title page.
// Field keys must match backend/src/lib/commercial-title-page.js.

export const DURATION_OPTIONS = ['6', '15', '30', '45', '60'].map((s) => ({ value: s, label: `${s} seconds` }))
  .concat([{ value: 'Custom', label: 'Custom' }]);

export const MEDIUM_OPTIONS = ['Television', 'Online Video', 'Social Media', 'Cinema', 'Custom']
  .map((m) => ({ value: m, label: m }));

export const COMMERCIAL_SECTIONS = [
  {
    title: 'Project Information',
    fields: [
      { key: 'client', label: 'Client' },
      { key: 'brand', label: 'Brand / Product' },
      { key: 'campaign', label: 'Campaign' },
      { key: 'agency', label: 'Advertising Agency' },
      { key: 'productionCompany', label: 'Production Company' },
      { key: 'jobNumber', label: 'Job / Reference Number' },
    ],
  },
  {
    title: 'Commercial Details',
    fields: [
      { key: 'duration', label: 'Duration' },
      { key: 'medium', label: 'Medium / Format' },
      { key: 'territory', label: 'Territory / Market' },
      { key: 'version', label: 'Version / Draft' },
      { key: 'date', label: 'Date', type: 'date' },
      { key: 'status', label: 'Status (optional)' },
    ],
  },
  {
    title: 'Contacts',
    fields: [
      { key: 'agencyContactName', label: 'Agency Contact – Name' },
      { key: 'agencyContactDepartment', label: 'Agency Contact – Department' },
      { key: 'agencyContactEmail', label: 'Agency Contact – Email', type: 'email' },
      { key: 'agencyContactPhone', label: 'Agency Contact – Phone', type: 'tel' },
      { key: 'clientContactName', label: 'Client Contact – Name' },
      { key: 'clientContactRole', label: 'Client Contact – Role' },
      { key: 'clientContactEmail', label: 'Client Contact – Email', type: 'email' },
      { key: 'clientContactPhone', label: 'Client Contact – Phone', type: 'tel' },
      { key: 'writer', label: 'Writer' },
      { key: 'director', label: 'Director' },
    ],
  },
  {
    title: 'Additional Information',
    fields: [
      { key: 'brief', label: 'Creative Brief / Notes', multiline: true },
      { key: 'avRequirements', label: 'Audio / Visual Requirements', multiline: true },
      { key: 'confidentiality', label: 'Confidentiality Notice', multiline: true },
    ],
  },
];

const clean = (v) => (v === undefined || v === null ? '' : String(v).trim());

// Display value for a field, resolving Custom duration/medium.
export const commercialValue = (c = {}, key) => {
  if (key === 'duration') {
    const d = clean(c.duration);
    if (d === 'Custom') return clean(c.durationCustom);
    return d ? `${d} seconds` : '';
  }
  if (key === 'medium') return clean(c.medium) === 'Custom' ? clean(c.mediumCustom) : clean(c.medium);
  return clean(c[key]);
};

export const hasCommercialContent = (c = {}) =>
  COMMERCIAL_SECTIONS.some((s) => s.fields.some((f) => commercialValue(c, f.key)));
